const signRouter = [
	{
		path: '/sign-in',
		name: 'SignIn',
		component: () => import('../template/UserTemplate.vue'),
	},
]

export default signRouter
